module.exports = __webpack_public_path__ + "img/mobile_caret_left.23532.png";